import React, { useState } from "react";
import Logo from "@/components/Logo";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errText } from "@/lib/api";

export default function Registro() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cargando, setCargando] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      const data = await register(nombre, email, password);
      nav(data.reconocido ? "/bienvenida" : "/conocerte");
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="min-h-screen bg-negro flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <Logo variant="full" height={120} className="mb-12 mx-auto block" />
        <h1 className="titulo text-5xl mb-3">Creá tu cuenta.</h1>
        <p className="text-gris mb-10">Tres datos y arrancamos. Nada más.</p>

        <form onSubmit={submit} className="space-y-4">
          <input className="input-dark" placeholder="¿Cómo te llamás?" value={nombre} onChange={(e) => setNombre(e.target.value)} required data-testid="registro-nombre" />
          <input className="input-dark" type="email" placeholder="Tu mail" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="registro-email" />
          <input className="input-dark" type="password" placeholder="Una contraseña" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="registro-password" />
          <button className="btn-dorado w-full mt-2" disabled={cargando} data-testid="registro-submit">{cargando ? "CREANDO…" : "CREAR CUENTA"}</button>
        </form>

        <div className="mt-8 text-sm">
          <Link to="/login" className="text-gris hover:text-dorado transition-colors" data-testid="link-login">Ya tengo cuenta</Link>
        </div>
      </motion.div>
    </div>
  );
}
